import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styles from './UpsellSignUp.module.scss';

const UpsellSignUp = ({ user, mobile }) => {
  return (
    <div
      className={`${styles.upsellContainer} ${
        mobile ? styles.upsellMobile : styles.upsellDesktop
      }`}
    >
      {!user && (
        <>
          <p className={styles.upsellTitle}>
            Get the latest jobs in your inbox
          </p>
          <p>💼 Freelance + remote jobs</p>
          <p>⚡️ Easy applications</p>
          <p>📋 Portfolio + web builder</p>
          <Button
            href="/signup"
            className={styles.upsellButton}
            bsStyle="primary"
          >
            Sign up for free
          </Button>
        </>
      )}
      {user && user?.pro === false && (
        <>
          <p className={styles.upsellTitle}>
            🚀 Upgrade to Twine Pro and win more work
          </p>
          <p>💬 Apply to more jobs</p>
          <p>🌐 One-page website</p>
          <p>✨ AI pitch + cover letter tool</p>
          <Button
            href="/pricing/creative"
            className={styles.upsellButton}
            bsStyle="primary"
          >
            Upgrade now
          </Button>
        </>
      )}
    </div>
  );
};

UpsellSignUp.propTypes = {
  user: PropTypes.object,
  mobile: PropTypes.bool,
};

UpsellSignUp.defaultProps = {
  mobile: false,
};

export default UpsellSignUp;
